import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "danger",
  "use": "danger-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"danger\"><defs><style>#danger .cls-1{fill-rule:evenodd}#danger .cls-2{fill:none}</style></defs><title>资源 6</title><g id=\"danger_图层_2\" data-name=\"图层 2\"><g id=\"danger_图层_1-2\" data-name=\"图层 1\"><path id=\"danger_Fill-1\" class=\"cls-1\" d=\"M13.62 9.19a1.62 1.62 0 1 0-3.24 0v.15l1.12 6.07a.57.57 0 0 0 1.13 0l1-6.08zM12 18.75a1.13 1.13 0 1 0-1.13-1.13A1.13 1.13 0 0 0 12 18.75zm10.08 2.46a2.69 2.69 0 0 1-2.33 1.29H4.25a2.69 2.69 0 0 1-2.33-1.29 2.63 2.63 0 0 1-.11-2.67L9.54 3A2.71 2.71 0 0 1 12 1.5 2.66 2.66 0 0 1 14.44 3l7.75 15.52a2.63 2.63 0 0 1-.11 2.69z\" /><path class=\"cls-2\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/danger.svg
// module id = vyad
// module chunks = 6